var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from "react";
import { createRoot } from "react-dom/client";
import isEqual from "react-fast-compare";
import { EventManager, addToRegister, unregisterAll } from "../../utils/EventManager";
var Tooltip = /** @class */ (function (_super) {
    __extends(Tooltip, _super);
    function Tooltip() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onTooltipOrNode = false;
        _this.events = [];
        _this.LISTENERS = {
            nodeClickOrLeave: function () {
                _this.onTooltipOrNode = false;
                _this.element.remove();
            },
            nodeMouseEnter: function (e) {
                _this.element.relativeElement = e.target;
                _this.onTooltipOrNode = true;
                if (_this.props.label)
                    document.body.appendChild(_this.element);
                _this.positionTooltip(_this.element);
                _this.observer.observe(_this.element, { childList: true });
            },
            windowResizeOrScroll: function () { return _this.positionTooltip(_this.element); },
            windowMouseOut: function () { return !_this.onTooltipOrNode && _this.element.remove(); },
            windowClick: function () { var _a; return (_a = _this.element) === null || _a === void 0 ? void 0 : _a.remove(); }
        };
        _this.renderTooltip = function () {
            var _a = _this.props, label = _a.label, position = _a.position, tooltipEl = document.createElement("div");
            tooltipEl.classList.add("dolfo-tooltip");
            if (position)
                tooltipEl.classList.add(position);
            createRoot(tooltipEl).render(label);
            addToRegister(_this.events, new EventManager("mouseout", _this.LISTENERS.windowMouseOut));
            addToRegister(_this.events, new EventManager("resize", _this.LISTENERS.windowResizeOrScroll));
            addToRegister(_this.events, new EventManager("scroll", _this.LISTENERS.windowResizeOrScroll).addOptions(true));
            addToRegister(_this.events, new EventManager("click", _this.LISTENERS.windowClick).addOptions(true));
            _this.element = tooltipEl;
            if (!_this.observer)
                _this.observer = new MutationObserver(function () { return _this.positionTooltip(_this.element); });
        };
        _this.componentDidMount = function () { return _this.renderTooltip(); };
        _this.componentWillUnmount = function () {
            _this.LISTENERS.windowClick();
            unregisterAll(_this.events);
            _this.observer.disconnect();
        };
        _this.componentDidUpdate = function (prevProps) {
            if (!isEqual(prevProps.label, _this.props.label)) {
                _this.element.remove();
                _this.renderTooltip();
            }
        };
        _this.positionTooltip = function (tooltip, tries, place) {
            if (tries === void 0) { tries = []; }
            if (!document.body.contains(tooltip))
                return;
            var copy = tooltip.cloneNode(true), position = _this.props.position, placement = place || position || "top";
            copy.relativeElement = tooltip.relativeElement;
            copy.style.animation = "showTooltip 0s forwards";
            copy.style.visibility = "hidden";
            document.body.appendChild(copy);
            var tooltipPos = copy.getBoundingClientRect(), relativeElement = copy.relativeElement, nodePos = relativeElement.getBoundingClientRect();
            copy.setAttribute("class", "dolfo-tooltip " + placement);
            if (placement === "right") {
                copy.style.left = nodePos.left + 5 + nodePos.width + "px";
                copy.style.top = nodePos.top - (tooltipPos.height / 2) + (nodePos.height / 2) + "px";
            }
            else if (placement === "bottom") {
                copy.style.left = nodePos.left - (tooltipPos.width / 2) + (nodePos.width / 2) + "px";
                copy.style.top = nodePos.top + 5 + nodePos.height + "px";
            }
            else if (placement === "left") {
                copy.style.left = nodePos.left - 5 - tooltipPos.width + "px";
                copy.style.top = nodePos.top - (tooltipPos.height / 2) + (nodePos.height / 2) + "px";
            }
            else {
                copy.style.left = nodePos.left - (tooltipPos.width / 2) + (nodePos.width / 2) + "px";
                copy.style.top = nodePos.top - 5 - tooltipPos.height + "px";
            }
            if (!_this.isTooltipInViewport(copy) && tries.length < 4) {
                var dirs = ["top", "left", "right", "bottom"], exclude = dirs.filter(function (d) { return !tries.includes(d) && d !== placement; });
                tries.push(placement);
                _this.positionTooltip(tooltip, tries, exclude[0]);
            }
            else {
                tooltip.style.left = copy.style.left;
                tooltip.style.top = copy.style.top;
                tooltip.setAttribute("class", copy.getAttribute("class"));
            }
            copy.remove();
        };
        _this.isTooltipInViewport = function (el) {
            var rect = el.getBoundingClientRect();
            return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
        };
        _this.render = function () {
            var _a = _this.props, children = _a.children, onClick = _a.onClick;
            return React.Children.map(children, function (c) {
                return React.cloneElement(c, {
                    onMouseEnter: function (e) {
                        _this.LISTENERS.nodeMouseEnter(e);
                        if (c.props.onMouseEnter)
                            c.props.onMouseEnter(e);
                    },
                    onMouseLeave: function (e) {
                        _this.LISTENERS.nodeClickOrLeave();
                        if (c.props.onMouseLeave)
                            c.props.onMouseLeave(e);
                    },
                    onClick: function (e) {
                        _this.LISTENERS.nodeClickOrLeave();
                        if (c.props.onClick)
                            c.props.onClick(e);
                        if (onClick)
                            onClick(e);
                    }
                });
            });
        };
        return _this;
    }
    return Tooltip;
}(React.Component));
export { Tooltip };
